import { useEffect, useRef } from "react";
import gsap from "gsap";
import Spinner from "../../../shared/components/ui/Spinner";
import BarChart from "./BarChart";

export default function CameraStatsSection({ cameraStats, showRain }) {
  const cardsRef = useRef([]);

  useEffect(() => {
    if (cameraStats && cardsRef.current.length) {
      gsap.fromTo(
        cardsRef.current.filter(Boolean),
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.4, stagger: 0.05, ease: "power2.out" }
      );
    }
  }, [cameraStats]);

  if (!cameraStats) {
    return (
      <div className="stats-loading-section">
        <Spinner size="md" />
        Loading camera statistics...
      </div>
    );
  }

  const {
    cameras,
    lenses,
    focal_lengths,
    apertures,
    isos,
    shutter_speeds,
    averages,
    processed,
    with_exif,
    with_faces,
  } = cameraStats;

  return (
    <div className={`camera-stats-grid ${showRain ? "matrix-grid" : ""}`}>
      {/* Summary row */}
      <div className="stat-cards-grid">
        <div className="stat-card total" ref={(el) => (cardsRef.current[0] = el)}>
          <span className="stat-value">{processed || 0}</span>
          <span className="stat-label">Images Analyzed</span>
        </div>
        <div className="stat-card info" ref={(el) => (cardsRef.current[1] = el)}>
          <span className="stat-value">{with_exif || 0}</span>
          <span className="stat-label">With EXIF Data</span>
        </div>
        <div className="stat-card done" ref={(el) => (cardsRef.current[2] = el)}>
          <span className="stat-value">{with_faces || 0}</span>
          <span className="stat-label">With Faces</span>
        </div>
        {averages?.faces_per_image && (
          <div className="stat-card processing" ref={(el) => (cardsRef.current[3] = el)}>
            <span className="stat-value">{averages.faces_per_image.toFixed(1)}</span>
            <span className="stat-label">Avg Faces/Image</span>
          </div>
        )}
        {averages?.file_size_mb && (
          <div className="stat-card warning" ref={(el) => (cardsRef.current[4] = el)}>
            <span className="stat-value">{averages.file_size_mb.toFixed(1)} MB</span>
            <span className="stat-label">Avg File Size</span>
          </div>
        )}
      </div>

      {/* Charts grid */}
      <div className="charts-grid">
        <BarChart data={cameras} title="Camera Models" color="#ff9b64" showRain={showRain} />
        <BarChart data={lenses} title="Lenses" color="#a29bff" showRain={showRain} />
        <BarChart data={focal_lengths} title="Focal Lengths" color="#66ffb7" showRain={showRain} />
        <BarChart data={apertures} title="Apertures" color="#8ce5ff" showRain={showRain} />
        <BarChart data={isos} title="ISO" color="#ffeb3b" showRain={showRain} />
        <BarChart data={shutter_speeds} title="Shutter Speeds" color="#ff6b9d" showRain={showRain} />
      </div>
    </div>
  );
}
